import React from "react";
import logo from "../logo.png";
import {
  Button,
  Container,
  Dropdown,
  DropdownButton,
  ButtonGroup,
} from "react-bootstrap";
import InfoCard from "../components/InfoCard";

class HomePage extends React.Component {
  render() {
    return (
      <div className="HomePage">

        <section className="py-5 text-center">
          <Container>
            <img src={logo} className="hero-logo mb-4" alt="logo" />
            <h1>
              Benvenuto su {process.env.REACT_APP_WEBSITE_NAME}
            </h1>
            <p className="hero-text">
              La più grande community italiana dedicata ad Age of Empires.
              <br />
              Un luogo accogliente dove giocare, migliorare e partecipare a eventi e tornei.
              <br />
              Da noi puoi trovare sempre qualcuno con cui divertirti e crescere.
            </p>
            <div>
              <Button
                variant="primary"
                href="https://discord.com/invite/age-of-empires-italia-185687473337139200"
                target="_blank"
                className="me-2 mb-2"
              >
                Entra nel nostro server Discord
              </Button>
              <Button
                variant="secondary"
                href="https://support.discord.com/hc/it/articles/360033931551-Cominciamo"
                target="_blank"
                rel="noreferrer"
                className="me-2 mb-2">
                Non hai Discord?
              </Button>
              <DropdownButton
                variant="danger"
                as={ButtonGroup}
                title="Non hai il gioco?"
                id="bg-nested-dropdown"
                className="me-2 mb-2"
              >
                <Dropdown.Item
                  href="https://store.steampowered.com/app/1466860/Age_of_Empires_IV/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Age of Empires 4
                </Dropdown.Item>
                <Dropdown.Item
                  href="https://www.cdkeys.com/age-of-empires-iv-pc-steam?mw_aref=AoeItalia"
                  target="_blank"
                  rel="noreferrer"
                >
                  Age of Empires 4 (cdkeys)
                </Dropdown.Item>
                <Dropdown.Item
                  href="https://www.instant-gaming.com/it/2244-comprare-age-of-empires-iv-pc-gioco-steam/?igr=aoeitalia"
                  target="_blank"
                  rel="noreferrer"
                >
                  Age of Empires 4 (Instant Gaming)
                </Dropdown.Item>
              </DropdownButton>
            </div>
          </Container>
        </section>

        {/* INFO GRID */}
        <section className="info-section py-5">
          <Container>
            <InfoCard
              color="var(--aoe-black)"
              title="Chat Vocali"
              text="Entra nelle chat vocali di Discord per organizzare le partite, coordinarti con la squadra e conoscere nuovi giocatori. La comunicazione è il cuore della nostra community."
            ></InfoCard>
            <InfoCard
              color="#008000"
              title="Combriccola"
              text="Già un gruppo di amici? Perfetto. Unitevi al nostro server Discord: creeremo per voi canali vocali privati e uno spazio dedicato. Potrete fondare il vostro Clan, reclutare nuovi membri e partecipare alle competizioni ufficiali."
            ></InfoCard>
            <InfoCard
              color="#4169e1"
              title="Coaching"
              text="Vuoi migliorare? Entra in un canale vocale e osserva le partite dei giocatori più esperti. Saranno felici di rispondere alle tue domande e condividere strategie utili."
            ></InfoCard>
            <InfoCard
              color="#964B00"
              title="Clan"
              text="Cerchi un Clan o vuoi unirti a una squadra? Scrivi nel canale #⛺-reclutamento. Ricorda: il primo canale vocale di ogni Clan è sempre accessibile a tutti, così puoi conoscere i membri prima di entrare."
            ></InfoCard>
            <InfoCard
              color="#FFD700"
              title="Tornei"
              text="Vuoi partecipare ai nostri tornei? Controlla il canale #📢-annunci per restare aggiornato sugli eventi in arrivo e sulle iscrizioni aperte."
            ></InfoCard>
            <InfoCard
              color="#C0C0C0"
              title="Bot"
              text="Abbiamo sviluppato un bot dedicato alla community! Usalo nel canale #🤖-bot-spam per bilanciare automaticamente le squadre o scoprire funzioni utili. Digita !help per vedere tutti i comandi disponibili."
            ></InfoCard>
            <InfoCard
              color="#6495ed"
              title="Casting"
              text="Trasmettiamo e commentiamo partite, tornei e amichevoli sul nostro canale Twitch. Vuoi fare il telecronista, apparire nei video o proporre contenuti? Contatta lo @staff."
            ></InfoCard>
            <InfoCard
              color="#8b008b"
              title="Ranghi"
              text="Ogni giocatore ha un rango che rappresenta il suo livello 1vs1. Tagga il tuo rango nel canale 🔎-ricerca-partite per trovare avversari del tuo livello e organizzare sfide equilibrate."
            ></InfoCard>
          </Container>
        </section>

        {/* DISCORD STATS */}
        <section className="discord-section text-center py-5">
          <Container>
            <iframe
              title="Discord widget"
              src="https://discord.com/widget?id=185687473337139200&amp;theme=dark"
              width="350"
              height="500"
              allowtransparency="true"
              frameBorder="0"
              sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
              className="mt-4"
            ></iframe>
          </Container>
        </section>

      </div>
    );
  }
}

export default HomePage;
